import type { Customer } from '@/customers/hooks';
import type { TenantSettings } from '@/settings/hooks';

/**
 * Доступность каналов отправки для клиента — единый источник правды
 * (architecture.md §8, dispatch.choose_channel на бэке).
 *
 * Правила:
 *   - Telegram доступен, если клиент привязан (`linked_at != null`).
 *   - SMS доступен, если включён глобально (env `SMS_ENABLED` →
 *     `sms_globally_enabled`) И не придавлен kill-switch'ем тенанта.
 *   - Живой канал есть, если доступен хотя бы один.
 *
 * Используется и в `SendMessageDialog` (гейт submit + no-channel alert),
 * и в `OrderDetailPage` (кнопка/alert на карточке suggested-template).
 * До загрузки данных (`customer`/`tenantSettings` == null) считаем канал
 * недоступным — вызывающий сам решает, показывать ли «нет канала» только
 * когда обе query успешно отдали данные (см. `channelsResolved`).
 */
export interface ChannelAvailability {
  isLinked: boolean;
  smsAvailable: boolean;
  hasLiveChannel: boolean;
}

export function deriveChannelAvailability(
  customer: Customer | null,
  tenantSettings: TenantSettings | null,
): ChannelAvailability {
  const isLinked = customer ? customer.linked_at !== null : false;
  const smsAvailable = tenantSettings
    ? tenantSettings.sms_globally_enabled && !tenantSettings.sms_kill_switch
    : false;
  return { isLinked, smsAvailable, hasLiveChannel: isLinked || smsAvailable };
}
